<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="MSISDN wijzigen"
      :large="false"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <fade-transition group>
        <dean-form-row id="simNumber" label="sim-nummer" type="string" v-model="data.simNumber"
                       key="simNumber" :requiredField="true"
                       :warning="$v.data.simNumber.$error"></dean-form-row>
      </fade-transition>

      <fade-transition group>
        <dean-form-row id="msisdn" label="msisdn" type="string" v-model="data.msisdn"
                       key="msisdn" :requiredField="true"
                       :warning="$v.data.msisdn.$error"></dean-form-row>
      </fade-transition>

      <fade-transition group>
        <dean-form-row id="msisdnToPort" label="porteren msisdn" type="string" v-model="data.msisdnToPort"
                       key="msisdnToPort" :disabled="!this.payloadData.isPorting"
                       :warning="$v.data.msisdnToPort.$error"></dean-form-row>
      </fade-transition>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import axios from 'axios';
import {
  warningIcon,
  deanDialog,
  deanDialogButtonGroup,
  saveIcon,
} from '@deanone/dean-components';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotificationFromData, validationMessage} from '@/mixins/validations';
import {FadeTransition} from 'vue2-transitions';
import {getErrorFromResponse} from "@/mixins/errorMessage";

@Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class ChangeMsisdnDialog extends Vue {
  @Prop() public payloadData!: any;

  @Validations()
  get validations() {
    return {
      data: {
        simNumber: {required},
        msisdn: {required},
        msisdnToPort: {},
      },
    };
  }

  public data: {[key: string]: any} = {
    simNumber: this.payloadData.simNumber,
    msisdn: this.payloadData.msisdn,
    msisdnToPort: this.payloadData.msisdnToPort,
  };

  public close() {
    deanDialogBus.$emit('close');
  }

  public save() {
    // @ts-ignore-next-line
    this.$v.data.$touch();

    if (!this.$v.$invalid) {
      this.$emit('setLoad', true);

      const requestPayload: {[key: string]: any} = {
        orderLineId: this.payloadData.orderLineId,
        simNumber: this.data.simNumber,
        msisdn: this.data.msisdn,
      };

      if (this.payloadData.isPorting) {
        requestPayload.msisdnToPort = this.data.msisdnToPort;
      }

      axios.post('/-/trade/api/order.line.change.msisdn', requestPayload).then(
        (response: any) => {
          deanDialogBus.$emit('saved');
          this.$toast({
            icon: saveIcon,
            text: 'MSISDN succesvol gewijzigd.',
            theme: 'success',
          });
          this.close();
        },
        (error: any) => {
          const errorResponse = error.response.data;
          const errorMessage: string | null = getErrorFromResponse(errorResponse, this.$store.state.main.notification.messages.couldNotSendData.text);

          this.$toast(validationMessage(errorMessage));
        },
      ).finally(() => {
        this.$emit('setLoad', false);
      });
    } else {
      this.$toast(createNotificationFromData(this.$v.data));
    }
  }

  public created() {
    this.$emit('setLoad', false);
  }
}
</script>

<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

:deep(.dialog .dean-dialog-container) {
  width: 600px;
}

:deep(.dean-dialog-content .dean-dialog-slot) {
  overflow-y: visible;
}
</style>
